import React from "react";

function copyright() {
  return (
    <div className="sidebar_brand text-left">
      <p>© IDrive Inc.</p>
    </div>
  );
}

export default copyright;
